/**
 * @generated SignedSource<<3517c117086d8834936949fa69974fca>>
 * @relayHash 48e82d86f9f82c64da7e6921d4088449
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5a1127c0ad7c1679013b6559593d335e4d9756338f21e2c3f8dfc1c43dc6936e

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { profileMenuQuery } from './profileMenuQuery.graphql';

const node: PreloadableConcreteRequest<profileMenuQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "5a1127c0ad7c1679013b6559593d335e4d9756338f21e2c3f8dfc1c43dc6936e",
    "metadata": {},
    "name": "profileMenuQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
